var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49984 12.8333C10.7215 12.8333 13.3332 10.2216 13.3332 6.99996C13.3332 3.7783 10.7215 1.16663 7.49984 1.16663C4.27818 1.16663 1.6665 3.7783 1.6665 6.99996C1.6665 10.2216 4.27818 12.8333 7.49984 12.8333Z",
    stroke: "url(#paint0_linear_12494_13829)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 7H13.3332",
    stroke: "url(#paint1_linear_12494_13829)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49984 1.16663C8.95892 2.764 9.78811 4.83698 9.83317 6.99996C9.78811 9.16294 8.95892 11.2359 7.49984 12.8333C6.04076 11.2359 5.21156 9.16294 5.1665 6.99996C5.21156 4.83698 6.04076 2.764 7.49984 1.16663V1.16663Z",
    stroke: "url(#paint2_linear_12494_13829)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12494_13829",
    x1: 7.49984,
    y1: 1.16663,
    x2: 7.49984,
    y2: 12.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12494_13829",
    x1: 7.49984,
    y1: 7,
    x2: 7.49984,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12494_13829",
    x1: 7.49984,
    y1: 1.16663,
    x2: 7.49984,
    y2: 12.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF97FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobusIcon);
export default __webpack_public_path__ + "static/media/globusIcon.04dc1948c9664f10fc0ec632edfc7400.svg";
export { ForwardRef as ReactComponent };